<template>
  <div>
    <validation-observer ref="forms" v-slot="{ handleSubmit }">
      <form class="form-group" @submit.prevent="handleSubmit(submitBoleto)">
        <div class="grid-2">
          <validation-provider
            name="Sindicato"
            vid="sindicato"
            rules="required"
            v-slot="{ errors }"
            tag="div"
            class="input-std form-text"
          >
            <label for="">Sindicatos</label>
            <select v-model="form.sindicato_id" class="text-black">
              <option value="" disabled></option>
              <option
                v-for="(sindicato, index) in sindicatos"
                :key="index"
                :value="sindicato.id"
              >
                {{ sindicato.nome_fantasia }}
              </option>
            </select>
            <p class="errors">{{ errors[0] }}</p>
          </validation-provider>
        </div>
        <div class="grid-2">
          <validation-provider
            name="Sindicato"
            vid="sindicato"
            rules="required"
            v-slot="{ errors }"
            tag="div"
            class="input-std form-text"
          >
            <label for="">Data Vencimento</label>
            <flat-pickr
              v-model="form.data_vencimento"
              :config="config"
              name="data-juros"
              id="data-juros"
              placeholder="Selecione a data de início do juros"
            >
            </flat-pickr>
            <p class="errors">{{ errors[0] }}</p>
          </validation-provider>

           <validation-provider
            name="Valor Documento"
            vid="valor_documento"
            rules="required"
            v-slot="{ errors }"
            tag="div"
            class="input-std form-text"
          >
            <label for="">Valor do Documento</label>
            <input type="text" v-model="form.valor"/>
            <p class="errors">{{ errors[0] }}</p>
          </validation-provider>
        </div>
        <div class="flex justify-end">
          <button type="submit" class="btn btn-primary">Gerar Boleto</button>
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/airbnb.css";

const Brasil = require("flatpickr/dist/l10n/pt.js").default.pt;
export default {
  components: {
    flatPickr,
  },

  created() {
    this.getSindicatos();
  },

  data() {
    return {
        sindicatos: [],
        form: {
          operacao: 'INCLUI_BOLETO',
          data_vencimento: "",
          numero_documento: this.gerarNumeroDocumento(),
          sindicato_id: '',
          valor: '',
        },
        config: {
            wrap: true,
            altInput: true,
            altFormat: 'd/m/Y',
            dateFormat: 'Y-m-d',
            enableTime: true,
            allowInput: true,
            locale: Brasil,
        },
    };
  },

  methods: {
    getSindicatos() {
      this.axios("get-all-sindicatos").then((response) => {
        this.sindicatos = response.data.sindicato;
      });
    },

    gerarNumeroDocumento() {
      let prefix = 'BO'
      let ano = new Date().getFullYear()
      let mes = new Date().getMonth() + 1
      if (mes == 13) {
        mes -= -1
      }

      return prefix+mes+ano
    },

    submitBoleto() {
        this.axios.post('incluir-boleto', this.form)
        .then(response => {
          this.$swal({
              title: 'Sucesso',
              text: 'Boleto gerado com sucesso.',
              icon: 'success',
            });
          this.$router.push('/sistema/boletos/lista-boletos')
        })
        .catch(error => {
          this.$swal({
            title: 'Ops!',
            text: error.response.data.mensagem,
            icon: 'error',
          });
        })
    }
  },
};
</script>